import "../sass/style.scss";
import { Common } from './js/common.js';

class CAPO {
  constructor() {
    this.common = new Common();
    this.viewDidLoad();
  }

  viewDidLoad() {
    /**
     * ヘッダーナビの初期設定
     */
    this.common.init_header_nav();

    /**
     * Footer PAGE TOPボタン
     */
    const footerPageTop = $('#js-FooterPageTopBtn');
    footerPageTop.click(function () {
      $('body, html').animate({ scrollTop: 0 }, 500); //0.5秒かけてトップへ戻る
      return false;
    });

    if ($('body').hasClass('home')) {
      /** 
       * トップページ コンタクトボタンアニメーション
      */
      $('#js-ContactBtn').addClass('fadeIn');
      /** 
       * トップページ コンタクトボタンアニメーション
      */
      $('#js-HeaderWrap').addClass('fadeIn');
      /** 
       * ヘッダー白背景
      */
      $(window).on('scroll', function () {
        if ($(this).scrollTop() > $('#js-KeyVisual').outerHeight() - $('#js-HeaderWrap').outerHeight()) {
          $('#js-HeaderWrap').addClass('bg-active');
        } else {
          $('#js-HeaderWrap').removeClass('bg-active');
        }
      })
    } else {
      $('#js-HeaderWrap').addClass('bg-active');
    }

    /**
     * トップページ ニュース ホバー
     */
    $('.cpJs-TopNewsHover')
      .on('mouseover', function () {
        $(this).parents('#cpJs-TopNewsParents').find('#cpJs-TopNewsA').addClass('is-active');
      }).on('mouseout', function () {
        $(this).parents('#cpJs-TopNewsParents').find('#cpJs-TopNewsA').removeClass('is-active');
      });

    // /**
    //  * 固定 PAGE TOPボタン
    //  */
    // let appearFlag = false;
    // const pageTop = $('#js-PageTopBtn');
    // $(window).scroll(function () {
    //   if ($(this).scrollTop() > 1100) {  //100pxスクロールしたら
    //     if (appearFlag === false) {
    //       appearFlag = true;
    //       pageTop.stop().animate({
    //         'bottom': '60px' //下から60pxの位置に
    //       }, 200); //0.2秒かけて現れる
    //     }
    //   } else {
    //     if (appearFlag) {
    //       appearFlag = false;
    //       pageTop.stop().animate({
    //         'bottom': '-100px' //下から-100pxの位置に
    //       }, 100);
    //     }
    //   }
    // });
    // pageTop.click(function () {
    //   $('body, html').animate({scrollTop: 0}, 500); //0.5秒かけてトップへ戻る
    //   return false;
    // });


    // /**
    //  * ColorBox セット
    //  */
    // $(".js-Modal").colorbox({
    //   inline: true,
    //   maxWidth: "90%",
    //   maxHeight: "90%",
    //   height: "auto",
    //   opacity: 0.8
    // });

    // /**
    //  * Top KeyVisual スライダー
    //  * @type {Swiper}
    //  */
    // const slider1 = new Swiper('.slider1', {
    //   autoplay: {
    //     delay: 5000,
    //   },
    //   loop: true,
    //   slidesPerView: 1,
    //   // spaceBetween: 10,
    //   centeredSlides: true,
    //   speed: 600,
    //   pagination: {
    //     el: '.swiper-pagination',
    //     type: 'bullets',
    //     clickable: true,
    //     renderBullet: function (index, className) {
    //       //中に数字を表示
    //       return '<span class="' + className + '">' + '0' + (index + 1) + '</span>';
    //     }
    //   }
    // });

    /**
     * Top 最新記事 スライダー
     * @type {Swiper}
     */
    // const slider2 = new Swiper('#cpJs-topBlogSwiper', {
    //   // freeMode: true,
    //   // centeredSlides: true,
    //   autoplay: {
    //     delay: 5000,
    //   },
    //   loop: true,
    //   slidesPerView: 1.127,
    //   breakpoints: {
    //     768: {
    //       slidesPerView: 1.42,
    //     },
    //   },
    //   navigation: {
    //     nextEl: '.top-Blog_Slider_Next',
    //     prevEl: '.top-Blog_Slider_Prev',
    //   },
    // });


    /**
     * Top 最新記事 スライダー
     * @type {Swiper}
     */
    let settingsObj = {
      450: {
        slidesPerView: 1.5,
      },
      600: {
        slidesPerView: 1.9,
      },
    };
    for (let i = 1000; i < 3000; i += 2) {
      const addtional = (i - 1366) / 2;
      const value = 1 + (179 + addtional) / 423;

      settingsObj[i] = { 'slidesPerView': value };
    }

    this.slider3 = new Swiper('#cpJs-topBlogSwiper', {
      autoplay: {
        delay: 5000,
      },
      loop: true,
      slidesPerView: 1.127,
      breakpoints: settingsObj,
      navigation: {
        nextEl: '.top-Blog_Slider_Next',
        prevEl: '.top-Blog_Slider_Prev',
      },
    });

    window.addEventListener('resize', function () {
      window.CAPO.slider3.autoplay.start()
    });


    /**
     * コース feature スライダー
     * @type {Swiper}
     */
    const cpFeatureSwiper = new Swiper("#cpJs-CpFeatureSwiper", {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

window.CAPO = new CAPO();
